<div class="mobile-container">
  <div class="search-container" *ngIf="showVirtualAssistant">
    <div class="search-send-img">
      <img src="assets/images/ptl_homepage_icon.gif" alt="search icon" />
    </div>
    <input type="text" placeholder="{{ptlVAHomePageText?.tr_VAInputboxQuestion}}"  [(ngModel)]="vaInputValue" (keyup.enter)="routeToTab('va')" aria-label="Ask me about this device"/>
    <div class="search-send-img" (click)="routeToTab('va')">
      <img src="assets/images/wcl/wcl-va-search-icon.png" alt="search icon" />
    </div>
  </div>
  <div class="headline-section" [class.headline-top-margin]="!showVirtualAssistant">
      <img [src]="homepageHeadline" alt="headline icon" />
  </div>

  <div class="wcl-card-wrapper">
    <div class="wcl-card" *ngFor="let item of tileData; let i = index" (click)="openTileModal(tileModal, item)">
      <img [src]="item?.tileBadgeUrl" alt="tile-image" [ngClass]="isRTL ? 'rtlLang-img-alignment' :''" class="card-bg">
      <div class="card-content" [ngClass]="['wcl-' + item?.tileUrlName, isRTL ? 'rtlLang-alignment' : '', !enusAndRtlArray.includes(language) ? 'otherLang-alignment' : '']" [class.intelOne-display]="setFontIntelDisplayOne">
        <div class="card-content-title" [innerHTML]="item?.tr_pretitle"></div>
        <div class="card-content-subtitle" [innerHTML]="item?.tr_tileTitle"></div>
      </div>
     <ng-template #tileModal let-modal>
        <div class="modal-body" [class.modal-loading]="!videoLoaded">
          <div class="tile-modal-card" [ngStyle]="(langArray.includes(language))?{'height': '80vh'} : ((language=='uk')&&(isBatteryTile)) ? {'height': '85vh'} : {}">
            <div class="tile-video-wrapper">
              <video class="tile-video" [src]="isreliabilityTile ? tileDetails.titleArray[activeIndex].imgUrl : tileDetails.detailBGUrl" [poster]="isreliabilityTile ? tileDetails.titleArray[activeIndex].videoPosterUrl : tileDetails.videoPosterUrl" autoplay muted loop playsinline webkit-playsinline  preload="auto" (loadeddata)="onVideoLoaded()"></video>
            </div>
            <!-- CONTENT-->
            <div class="tile-modal-content" [ngClass]="isreliabilityTile ? 'icon-position' : ''" *ngIf="videoLoaded">
            <div class="reliability-tabs">
              <div class="reliability-icons" [ngClass]="j == activeIndex ? 'active-icon' : ''"
                *ngFor="let icons of tileDetails.badgeIcons; let j = index" (click)="onIconClick(j)">
                <img [src]="icons.badgeUrl" alt="reliability-icons">
              </div>
            </div>
            <div class="tile-modal-title" [ngClass]="[isreliabilityTile ? 'reliability-desc' : '', isBatteryTile ? 'battery-desc' : '']"
              [class.intelOne-display]="setFontIntelDisplayOne"
              [innerHTML]="isreliabilityTile ? tileDetails.titleArray[activeIndex].tr_title : tileDetails.tr_title">
            </div>
            <div class="tile-modal-subtitle" [class.intelOne-display]="setFontIntelDisplayOne"
              [class.battery-panel]="isBatteryTile"
              [innerHTML]="isreliabilityTile ? tileDetails.titleArray[activeIndex].tr_subtitle : tileDetails.tr_subtitle"
              [ngClass]="[isreliabilityTile ? 'reliability-modal-subtitle' : '', isperformanceTile ? 'performance-modal-subtitle' : '']">
            </div>
            <ul *ngIf="tileDetails.titleArray1" class="custom-list"  [class.UI-mr-left]="(language ==='ar-sa')||(language=== 'he')"
         [ngStyle]="language==='th'?{'line-height':'5.128vw'}:{}">
              <li *ngFor="let desc of tileDetails.titleArray1" [class.intelOne-display]="setFontIntelDisplayOne"
                [innerHTML]="desc?.tr_title" [ngClass]="[isBatteryTile ? 'battery-modal-list' : '', isperformanceTile ? 'performance-modal-list' : '']">
              </li>
            </ul>
            </div>
          </div>
 
          <div class="close-icon-std-12xe" (click)="closeModel()" *ngIf="videoLoaded">
            <img src="assets/images/touchless_popup_close_button.svg" alt="close">
          </div>
        </div>
     </ng-template>
     </div>
  </div>
  <div  class="legal-text" [class.intelOne-display]="setFontIntelDisplayOne" (click)="open(legalModal)">
  <span class="legal-text-decoration" [innerHTML]="legalText"></span>
  <span [innerHTML]="legalVersion"></span>
  </div>  
  

  <ng-template #legalModal let-modal tabindex="-1" role="dialog" aria-labelledby="legalTextModalLabel" aria-hidden="true">
  <div class="legal-modal-container" id="rtlDirection" [dir]="direction"
    [ngStyle]="{'text-align':(direction === 'rtl')? 'right' : ''}" [ngClass]="legalTextFontClass" [class.intelOne-display]="setFontIntelDisplayOne">
    <div id="modalHeaderLegalText" class="modal-header">
      <h2 class="modal-title" id="legalTextModalLabel" [class.intelOne-display]="setIntelDisplayOneFont"
        [innerHTML]="legalText"></h2>
      <button data-dismiss="modal" class="close" (click)="close()">
        <img src="assets/images/close_icon_legal_popup.svg" aria-hidden="true" class="close-icon" alt="close" />
      </button>
    </div>
    <div id="modalBodyLegalContent" class="modal-body">
      <p *ngFor='let value of legalContent' [innerHTML]="value">
      </p>
    </div>
  </div>
</ng-template>

</div>